(function () {
  'use strict';

  window.ppgReady = true;

  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  var motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function motionOk() {
    return motionQuery.matches && typeof Element.prototype.animate === 'function';
  }

  function animate(el, keyframes, options) {
    if (!el || !motionOk()) return;
    el.animate(keyframes, Object.assign({ easing: EASE }, options));
  }

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdowns(root) {
    each(root, '[data-ppg-countdown]', function (el) {
      if (el._ppgTimer) clearInterval(el._ppgTimer);
      var parts = (el.dataset.end || '').split('-').map(Number);
      if (parts.length !== 3 || parts.some(isNaN)) return;
      var end = new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime();
      var units = {
        days: el.querySelector('[data-unit="days"]'),
        hrs: el.querySelector('[data-unit="hrs"]'),
        mins: el.querySelector('[data-unit="mins"]'),
        secs: el.querySelector('[data-unit="secs"]')
      };

      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        units.days.textContent = pad(Math.floor(s / 86400));
        units.hrs.textContent = pad(Math.floor((s % 86400) / 3600));
        units.mins.textContent = pad(Math.floor((s % 3600) / 60));
        units.secs.textContent = pad(s % 60);
        if (s === 0) clearInterval(el._ppgTimer);
      }

      tick();
      el._ppgTimer = setInterval(tick, 1000);
    });
  }

  function initHero(root) {
    if (!motionOk()) return;
    each(root, '[data-ppg-kenburns]', function (img) {
      animate(img, [{ transform: 'scale(1.14)' }, { transform: 'scale(1)' }], { duration: 2600, fill: 'both' });
    });
    each(root, '.ppg-hero', function (hero) {
      each(hero, '[data-ppg-hero-item]', function (el, i) {
        animate(el, [{ opacity: 0, transform: 'translateY(32px)' }, { opacity: 1, transform: 'none' }], {
          duration: 900,
          delay: 120 + i * 90,
          fill: 'both'
        });
      });
    });
  }

  var revealObserver = null;

  function initReveal(root) {
    var targets = root.querySelectorAll('[data-ppg-reveal]:not(.is-revealed)');
    if (!targets.length) return;

    if (!document.documentElement.classList.contains('ppg-motion') || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-revealed'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }

    Array.prototype.forEach.call(targets, function (el) { revealObserver.observe(el); });
  }

  function initTabs(root) {
    each(root, '[data-ppg-tabs]', function (section) {
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.tabIndex = active ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();

        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (!panel) return;
        each(panel, '.ppg-card', function (card, i) {
          card.classList.add('is-revealed');
          animate(card, [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'none' }], {
            duration: 600,
            delay: i * 70,
            fill: 'both'
          });
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          if (tab.getAttribute('aria-selected') !== 'true') select(tab, false);
        });
        tab.addEventListener('keydown', function (evt) {
          var next = null;
          if (evt.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (evt.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (evt.key === 'Home') next = tabs[0];
          if (evt.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            evt.preventDefault();
            select(next, true);
          }
        });
      });

      section._ppgSelectTab = select;
    });
  }

  function cartRoutes() {
    var routes = (window.theme && window.theme.routes) || {};
    return {
      add: routes.cartAdd || '/cart/add.js',
      cart: routes.cart || '/cart.js'
    };
  }

  function setCartCount(count) {
    each(document, '[data-ppg-cart-count]', function (el) {
      var changed = el.textContent !== String(count);
      el.textContent = count;
      if (changed) {
        animate(el, [{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 400 });
      }
    });
  }

  function refreshCartCount() {
    return fetch(cartRoutes().cart, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  function swapCardImage(form, select) {
    var option = select.options[select.selectedIndex];
    var card = form.closest('.ppg-card');
    var img = card && card.querySelector('.ppg-card__img');
    if (!option || !img || !option.dataset.imageSrc || img.getAttribute('src') === option.dataset.imageSrc) return;
    img.srcset = option.dataset.imageSrcset || '';
    img.src = option.dataset.imageSrc;
    if (img.animate && document.documentElement.classList.contains('ppg-motion')) {
      img.animate([{ opacity: 0, transform: 'scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 400, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
  }

  function initAddToCart(root) {
    each(root, 'form[data-ppg-add]', function (form) {
      if (form._ppgBound) return;
      form._ppgBound = true;
      var button = form.querySelector('[type="submit"]');
      var error = form.querySelector('.ppg-card__error');
      var select = form.querySelector('select[name="id"]');

      function reset() {
        button.classList.remove('is-added');
        button.textContent = form.dataset.labelAdd;
        if (error) error.hidden = true;
      }

      if (select) select.addEventListener('change', reset);
      if (select) select.addEventListener('change', function () { swapCardImage(form, select); });

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;

        fetch(cartRoutes().add, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function (item) {
            button.classList.add('is-added');
            button.textContent = form.dataset.labelAdded;
            return refreshCartCount().then(function (cart) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, ppg: true } }));
              if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, ppg: true } }));
            });
          })
          .catch(function (data) {
            if (error) {
              error.textContent = (data && (data.description || data.message)) || form.dataset.labelError;
              error.hidden = false;
            }
          })
          .finally(function () {
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  function initHotspots(root) {
    each(root, '[data-ppg-hotspots]', function (section) {
      var colours = section.querySelectorAll('[data-ppg-colour]');
      var images = section.querySelectorAll('[data-ppg-colour-image]');
      var points = section.querySelectorAll('[data-ppg-hotspot]');
      var info = section.querySelector('[data-ppg-hotspot-info]');
      var num = section.querySelector('[data-ppg-hotspot-num]');
      var title = section.querySelector('[data-ppg-hotspot-title]');
      var text = section.querySelector('[data-ppg-hotspot-text]');

      Array.prototype.forEach.call(colours, function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-pressed') === 'true') return;
          var index = btn.dataset.ppgColour;
          Array.prototype.forEach.call(colours, function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          Array.prototype.forEach.call(images, function (img) {
            var active = img.dataset.ppgColourImage === index;
            img.hidden = !active;
            if (active) {
              animate(img, [{ opacity: 0, transform: 'translateX(24px) rotate(3deg)' }, { opacity: 1, transform: 'none' }], { duration: 600 });
            }
          });
        });
      });

      Array.prototype.forEach.call(points, function (point) {
        point.addEventListener('click', function () {
          Array.prototype.forEach.call(points, function (p) {
            p.setAttribute('aria-pressed', p === point ? 'true' : 'false');
          });
          if (num) num.textContent = Number(point.dataset.ppgHotspot) + 1;
          if (title) title.textContent = point.dataset.title;
          if (text) text.textContent = point.dataset.text;
          animate(info, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 350 });
        });
      });
    });
  }

  function initColourFeature(root) {
    each(root, '[data-ppg-colour-feature]', function (section) {
      var img = section.querySelector('[data-ppg-colour-img]');
      var name = section.querySelector('[data-ppg-colour-name]');
      var swatches = section.querySelectorAll('.ppg-colour__swatch');

      Array.prototype.forEach.call(swatches, function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.getAttribute('aria-pressed') === 'true') return;
          Array.prototype.forEach.call(swatches, function (s) {
            s.setAttribute('aria-pressed', s === swatch ? 'true' : 'false');
          });
          if (name) name.textContent = swatch.dataset.name;
          if (img && swatch.dataset.src) {
            if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
            img.src = swatch.dataset.src;
            img.alt = swatch.dataset.name;
            animate(img, [{ opacity: 0, transform: 'scale(.92) rotate(-4deg)' }, { opacity: 1, transform: 'none' }], { duration: 500 });
          }
        });
      });
    });
  }

  function init(root, isEditorLoad) {
    initCountdowns(root);
    if (!isEditorLoad) initHero(root);
    initReveal(root);
    initTabs(root);
    initAddToCart(root);
    initHotspots(root);
    initColourFeature(root);
  }

  function onReady() {
    init(document, false);

    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.ppg) return;
      if (evt.detail && evt.detail.cart) setCartCount(evt.detail.cart.item_count);
    });

    document.addEventListener('ajaxProduct:added', function (evt) {
      if (evt.detail && evt.detail.ppg) return;
      refreshCartCount();
    });

    document.addEventListener('shopify:section:load', function (evt) {
      init(evt.target, true);
    });

    document.addEventListener('shopify:block:select', function (evt) {
      var tab = evt.target;
      if (tab.getAttribute('role') !== 'tab') return;
      var section = tab.closest('[data-ppg-tabs]');
      if (section && section._ppgSelectTab) section._ppgSelectTab(tab, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
